<template>
  <el-form
    :inline="true"
    :label-width="`${labelwidth}px`"
    ref="form"
    :model="formData"
    v-if="fields.length"
  >
    <el-form-item label style="margin-bottom: 0">
      <el-select
        v-model="selectOption"
        size="small"
        @change="changeSelect"
        class="especially"
        style="width: 110px"
      >
        <el-option
          v-for="field in fields"
          :key="field.name"
          :label="field.label"
          :value="field.name"
        >
        </el-option>
      </el-select>
      <div
        v-for="field in fields"
        :key="field.name"
        v-show="selectOption == field.name"
        class="selectUserOptions"
      >
        <el-select
          :placeholder="field.pla"
          size="small"
          filterable
          class="especially2"
          clearable
          :style="`width: ${itemwidth}px`"
          @change="inputsearch"
          v-if="field.type === 'select'"
          v-model="selectContent"
        >
          <el-option
            v-for="dic in getDic(field.dic)"
            :key="dic.id"
            :label="dic.name"
            :value="dic.id"
          ></el-option>
        </el-select>
        <el-select
          :placeholder="field.pla"
          :remote-method="remoteMethodUser"
          :loading="loading"
          filterable
          remote
          reserve-keyword
          size="small"
          class="especially2"
          clearable
          :style="`width: ${itemwidth}px`"
          @change="inputsearch"
          v-if="field.type === 'user'"
          v-model="selectContent"
        >
          <el-option
            v-for="item in UserOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          :placeholder="field.pla"
          :remote-method="remoteMethodCompany"
          :loading="loading"
          filterable
          remote
          reserve-keyword
          size="small"
          class="especially2"
          clearable
          :style="`width: ${itemwidth}px`"
          @change="inputsearch"
          v-if="field.type === 'company'"
          v-model="selectContent"
        >
          <el-option
            v-for="item in CompanyOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-input
          :style="`width: ${itemwidth}px`"
          v-else-if="field.type === 'input-num'"
          v-model="selectContent"
          class="especially2"
          :placeholder="field.pla"
          @change="inputsearch"
          onkeyup="value=value.replace(/[^\d]/g,'').replace(/^0{1,}/g,'')"
        >
        </el-input>
        <el-input
          :style="`width: ${itemwidth}px`"
          v-else-if="field.type === 'input'"
          v-model="selectContent"
          class="especially2"
          :placeholder="field.pla"
          @change="inputsearch"
        >
        </el-input>
      </div>
    </el-form-item>
  </el-form>
  <el-form
    :inline="true"
    :label-width="`${labelwidth}px`"
    ref="form"
    :model="formData"
    v-else
  >
    <el-form-item label style="margin-bottom: 0">
      <el-select
        v-model="selectOption"
        size="small"
        @change="changeSelect"
        class="especially"
        style="width: 110px"
      >
        <el-option label="请选择" :value="1"> </el-option>
      </el-select>
      <div class="selectUserOptions">
        <el-input
          :style="`width: ${itemwidth}px`"
          v-model="selectContent"
          class="especially2"
          placeholder="请输入"
          @change="inputsearch"
        >
        </el-input>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
import {
  getUserController,
  getCompanyController,
} from "@/services/server/UserInterface";
export default {
  name: "ProjectSearch",
  props: {
    fields: Array,
    labelwidth: {
      type: Number,
      default: function() {
        return 90;
      },
    },
    itemwidth: {
      type: Number,
      default: function() {
        return 200;
      },
    },
  },
  data() {
    return {
      loading: false,
      UserOptions: [],
      CompanyOptions: [],
      formData: {},
      selectOption: null,
      selectContent: null,
    };
  },
  created() {
    if (this.fields.length) {
      this.onready();
    }
  },
  watch: {
    fields() {
      if (this.fields.length) {
        this.onready();
      }
    },
  },
  methods: {
    async remoteMethodCompany(query) {
      if (query !== "") {
        this.loading = true;
        let res = await getCompanyController({
          page: 1,
          pagesize: 20,
          name: query,
        });
        this.loading = false;
        this.CompanyOptions = res.data.data;
      } else {
        this.CompanyOptions = [];
      }
    },
    async remoteMethodUser(query) {
      if (query !== "") {
        this.loading = true;
        let res = await getUserController({
          page: 1,
          pagesize: 20,
          role: 5,
          name: query,
        });
        this.loading = false;
        this.UserOptions = res.data.data;
      } else {
        this.UserOptions = [];
      }
    },
    onready() {
      this.selectOption = this.fields[0].name;
      this.selectContent = null;
    },
    inputsearch() {
      if (this.selectContent !== "" || this.selectContent === 0) {
        this.$parent.esarchang(1);
      } else {
        this.selectContent = null;
        this.$parent.esarchang(1);
      }
    },
    changeSelect() {
      this.selectContent = null;
      this.$parent.esarchang();
    },
    getDic(field) {
      if (Array.isArray(field)) {
        return field;
      } else if (typeof field === "string") {
        return this.$getDicByField(field);
      } else {
        return [];
      }
    },
  },
};
</script>
<style scoped lang="less">
.especially /deep/.el-input__inner {
  border-radius: 5px 0 0 5px;
  border-right: 0;
}
.especially2 /deep/.el-input__inner {
  border-radius: 0 5px 5px 0;
  border-left: 0;
  height: 32px;
  font-size: 13px;
}
.especially /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-right: 0;
}
.especially2 /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-left: 0;
}
.el-container {
  display: flex;
  flex-direction: column;
}
.selectUserOptions {
  display: inline-block;
}
</style>
